// ■コンポーネント説明
// サービス、事例での関連サービス表示用コンポーネント

import React, { useMemo } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import UIBox from '@/components/UI/UIBox';

export interface ServiceRelationProps {
  currentServiceId?: string;
  currentTag?: readonly any[];
}

function checkDuplicate(arr1: any[], arr2: any[]) {
  return (
    [...arr1, ...arr2].filter(
      (item) => arr1.includes(item) && arr2.includes(item),
    ).length > 0
  );
}

const ServiceRelation: React.FC<ServiceRelationProps> = (props) => {
  const { currentServiceId, currentTag } = props;
  const currentTagArray = [];
  const checkTagArray = [];
  let displayServiceArray = [];
  let ShuffleFlag = false;

  const data = useStaticQuery<GatsbyTypes.ServiciesRelationRelationQuery>(
    graphql`
      query ServiciesRelationRelation {
        allMicrocmsService(
          sort: { order: DESC, fields: publishedAt }
          filter: { serviceId: { ne: "template" } }
        ) {
          edges {
            node {
              id
              description
              title
              serviceId
              publishedAt(formatString: "YYYY/MM/DD")
              displayIndex
              tag {
                id
                tag
              }
              category
              subCategory
            }
          }
        }
      }
    `,
  );

  currentTag.map(({ tag }) => currentTagArray.push(tag));

  const resetcheckTagArray = () => {
    checkTagArray.splice(0);
  };

  const outputHeading = function (input, text) {
    if (input.length) {
      return (
        <h3
          className="title-lv3-01"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: text,
          }}
        />
      );
    }
    return null;
  };

  // 関連サービスの取得
  data.allMicrocmsService.edges.map(({ node }) => {
    resetcheckTagArray();
    node.tag.forEach(({ tag }) => checkTagArray.push(tag));
    if (
      node.serviceId !== currentServiceId &&
      node.serviceId !== `cloud-solution` &&
      node.serviceId !== `web-solution` &&
      node.serviceId !== `web-creative` &&
      node.serviceId !== `digital-marketing` &&
      checkDuplicate(currentTagArray, checkTagArray)
    ) {
      displayServiceArray.push(node.serviceId);
    }

    return null;
  });

  // 関連サービス配列をランダムに並び替え、2つまでになるよう調整
  const arrayShuffle = (array: string[]) => {
    const tempArray = array;
    for (let i = array.length - 1; i > 0; i -= 1) {
      const r = Math.floor(Math.random() * (i + 1));

      const tmp = tempArray[i];
      tempArray[i] = tempArray[r];
      tempArray[r] = tmp;
    }

    const shuffledArray = [];
    let sortCount = 0;

    if (tempArray.length <= 2) {
      sortCount = tempArray.length;
    } else {
      sortCount = 2;
    }

    for (let i = 0; i < sortCount; i += 1) {
      shuffledArray.push(tempArray[i]);
    }

    return shuffledArray;
  };

  if (!ShuffleFlag) {
    displayServiceArray = useMemo(() => arrayShuffle(displayServiceArray), []);
    ShuffleFlag = true;
  }

  return (
    <div className="page-contents-feature">
      {outputHeading(displayServiceArray, `関連サービス`)}
      <div className="box-2rows">
        {React.Children.toArray(
          data.allMicrocmsService.edges.map(
            ({ node }) =>
              displayServiceArray.includes(node.serviceId) && (
                <>
                  <UIBox
                    key={node.serviceId}
                    title={node.title}
                    description={node.description}
                    link={
                      node.subCategory.length === 0
                        ? `/service/${node.category}/${node.serviceId}/`
                        : `/service/${node.category}/${node.subCategory}/${node.serviceId}/`
                    }
                    displayIndex={node.displayIndex}
                  />
                </>
              ),
          ),
        )}
      </div>
    </div>
  );
};

export default ServiceRelation;
